/**
 * Constants for OfferType component
 */

export const adjustmentTypes = [
  { label: "Decrease rate by", value: "DECREASE" },
  { label: "Increase rate by", value: "INCREASE" },
];

export const offerTypes = [
  { label: "Percentage", value: 2 },
  { label: "Flat", value: 1 },
];

export const TOTAL_PRICE_CALCULATION_TYPE = 1;

export const allCalculationTypes = [
  { label: "Apply to total price (before tax)", value: 1 },
  { label: "Apply to adults only price (before tax)", value: 2 },
  {
    label: "Apply to base price (exc. additional adults)",
    value: 0,
  },
];

// CRS integrations that only support discounting the total price (e.g. D-Edge)
// get this single option, and the picker is disabled so it cannot be changed.
export const limitedCalculationType = [
  {
    label: "Apply discount to total price (before tax)",
    value: TOTAL_PRICE_CALCULATION_TYPE,
  },
];

export const discountTypes = [
  { label: "All days of the week", value: 4 },
  { label: "Select days of week", value: 1 },
];

// A percentage amount is a share of the rate, and 100% is the whole of it — as
// a decrease that prices the stay at zero, which is as far as it can go. The
// same ceiling applies to an increase: the cap is on the size of the
// adjustment, not on the direction. Enforced on the "All days of the week"
// amount and on every "Select days of week" amount alike.
export const MAX_PERCENT_DISCOUNT = 100;

// Flat (currency) amounts are money off the rate, not a share of it, so they
// are bounded only by what a night can plausibly cost.
export const MAX_FIXED_DISCOUNT = 99999.99;
export const MAX_FIXED_DAY_DISCOUNT = 9999.99;

// Deliberately says "Amount", not "Discount": the same field holds an increase
// when the Adjustment is "Increase rate by", and calling that a discount would
// describe the opposite of what the number does.
export const PERCENT_DISCOUNT_LIMIT_MESSAGE = `Amount cannot be more than ${MAX_PERCENT_DISCOUNT}%`;

export const DAYS = ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat", "Sun"];

export const dayMap = new Map([
  ["Sun", 1],
  ["Mon", 2],
  ["Tue", 3],
  ["Wed", 4],
  ["Thur", 5],
  ["Fri", 6],
  ["Sat", 7],
]);

export const ROOMS_RATEPLANS_OPTIONS = [
  { label: "All Rooms & Rate Plans", value: "all" },
  { label: "Selected Rooms & Rate Plans", value: "select" },
];

// Keep stable default references for optional array props.
// Using `[]` directly in the function signature creates a *new* array on each render.
export const EMPTY_LIST = [];

// EO-1538: the Rooms & Rate Plans drawer opened from a view-only promo.
export const ROOMS_RATEPLANS_EDIT_INSTRUCTION =
  "Choose which Room Types and Rate Plans you would like to apply your promotion to.";
export const ROOMS_RATEPLANS_VIEW_INSTRUCTION =
  "The Room Types and Rate Plans this promotion applies to.";
